import { lazy } from 'react';
import withSuspense from '../../../helpers/withSuspense';
import LoadingIndicator from '../loading_indicator.jsx';

const FileUploadUppy = withSuspense(lazy(() => import('./FileUploadUppy.jsx')), LoadingIndicator);

export default FileUploadUppy;
